import { MtGroup, MtProjectGroup, MtUser } from "server/models"
import { inferLiteral, OrderType } from "client/utils"
import {
    PermissionType,
    AccountPermissionItem,
    ProjectPermissionItem,
    AccountPermissionsSectioned,
    ProjectPermissionsSectioned,
} from "client/store/utils"
import { UserFilters, GroupFilters, ProjectGroupFilters } from "client/store"
import * as types from "./types"


export const setAccountPermissions = (
    accountPermissions: AccountPermissionsSectioned,
    baseProjectPermissions: ProjectPermissionsSectioned,
) => ({
    type: inferLiteral(types.SET_ACCOUNT_PERMISSIONS),
    accountPermissions,
    baseProjectPermissions,
})

export const updateAccountPermission = (
    section: string,
    permissionId: string,
    type: PermissionType,
    value: AccountPermissionItem,
) => ({
    type: inferLiteral(types.UPDATE_ACCOUNT_PERMISSION),
    data: { section, permissionId, type, value },
})

export const toggleAccountPermissionCustomizable = (
    section: string,
    permissionId: string,
) => ({
    type: inferLiteral(types.TOGGLE_ACCOUNT_PERMISSION_CUSTOMIZABLE),
    section,
    permissionId,
})

export const updateBaseProjectPermission = (
    section: string,
    permissionId: string,
    type: PermissionType,
    value: ProjectPermissionItem,
) => ({
    type: inferLiteral(types.UPDATE_BASE_PROJECT_PERMISSION),
    data: { section, permissionId, type, value },
})

export const toggleBaseProjectPermissionCustomizable = (
    section: string,
    permissionId: string,
) => ({
    type: inferLiteral(types.TOGGLE_BASE_PROJECT_PERMISSION_CUSTOMIZABLE),
    section,
    permissionId,
})

// not assigned users
export const setAccountPermissionsUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_USER_IDS),
    userIds,
})
export const setAccountPermissionsUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setAccountPermissionsUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_USER_FILTERS),
    filters,
})
export const setAccountPermissionsUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_USER_SELECTED),
    selected,
})

// not assigned groups
export const setAccountPermissionsGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_GROUP_IDS),
    groupIds,
})
export const setAccountPermissionsGroupSort = (sortColumn: keyof MtGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setAccountPermissionsGroupFilters = (filters: GroupFilters) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_GROUP_FILTERS),
    filters,
})
export const setAccountPermissionsGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_GROUP_SELECTED),
    selected,
})

// not assigned project groups
export const setAccountPermissionsProjectGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_PROJECT_GROUP_IDS),
    groupIds,
})
export const setAccountPermissionsProjectGroupSort = (sortColumn: keyof MtProjectGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_PROJECT_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setAccountPermissionsProjectGroupFilters = (filters: ProjectGroupFilters) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_PROJECT_GROUP_FILTERS),
    filters,
})
export const setAccountPermissionsProjectGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_PROJECT_GROUP_SELECTED),
    selected,
})

export const setAccountPermissionsReloadList = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_PERMISSIONS_RELOAD_LIST),
    value,
})
